import { render, staticRenderFns } from "./Scrubber.vue?vue&type=template&id=21e1a23c&scoped=true&"
import script from "./Scrubber.vue?vue&type=script&lang=js&"
export * from "./Scrubber.vue?vue&type=script&lang=js&"
import style0 from "./Scrubber.vue?vue&type=style&index=0&id=21e1a23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1a23c",
  null
  
)

export default component.exports